module.exports = __webpack_public_path__ + "img/Haus,  Wohnen & Garten.794fc6a2.jpg";